import { object, string } from 'yup';

export const validationSchema = () =>
    object().shape({
        new_currency: string().required('Source Currency is required'),
        currency: string().required('Source Currency Value is required'),
        month: string().required('Month is required'),
        year: string().required('Year is required'),
    });
